export default __webpack_public_path__ + "static/media/loaction.f3314b7d.svg";